import {
  cancerSubtypeField,
  cancerTypeField,
  caseIdField,
  caseNameField,
  internallyApprovedField,
  studyField,
} from './caseFields';
import {
  biopsySiteField,
  markersField,
  ingestionDateField,
  metastasisField,
  negativeControlField,
  positiveControlField,
  slideIdField,
  stainTypeField,
} from './slideFields';

export default [
  caseIdField,
  caseNameField,
  slideIdField,
  markersField,
  internallyApprovedField,
  cancerTypeField,
  cancerSubtypeField,
  biopsySiteField,
  stainTypeField,
  metastasisField,
  negativeControlField,
  positiveControlField,
  ingestionDateField,
  studyField,
];
